
import tenant from '../config/tenant';

const BASE_URL = tenant.api.baseUrl;

const buildHeaders = (token) => {
  const headers = { 'Content-Type': 'application/json' };
  const authKey = 
    token || 
    localStorage.getItem('AuthKey') || 
    localStorage.getItem('auth-key') || 
    localStorage.getItem('auth_key') || 
    localStorage.getItem('token') || 
    localStorage.getItem('Authkey');
  if (authKey) {
    headers['auth-key'] = authKey;
    
  }
  return headers;
};

const handleResponse = async (res) => {
  if (!res.ok) {
    let message;
    try {
      message = await res.text();
    } catch {
      message = `HTTP ${res.status}`;
    }
    throw new Error(message || `API Error ${res.status}`);
  }
  return res.json();
};


const apiService = {

  get: (endpoint, token) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: 'GET',
      headers: buildHeaders(token),
    }).then(handleResponse),


  post: (endpoint, data, token) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: buildHeaders(token),
      body: JSON.stringify(data),
    }).then(handleResponse),

  put: (endpoint, data, token) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: buildHeaders(token),
      body: JSON.stringify(data),
    }).then(handleResponse),


  delete: (endpoint, token) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: buildHeaders(token),
    }).then(handleResponse),
};

export default apiService;

export { apiService as api };
